import { render, staticRenderFns } from "./SetGoodInvoice.vue?vue&type=template&id=23c092c4&scoped=true&"
import script from "./SetGoodInvoice.vue?vue&type=script&lang=js&"
export * from "./SetGoodInvoice.vue?vue&type=script&lang=js&"
import style0 from "./SetGoodInvoice.vue?vue&type=style&index=0&id=23c092c4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c092c4",
  null
  
)

export default component.exports